// 缦图旗下门店品牌
export const BRAND_HIMO = 'blue'
export const BRAND_HIMOGOLD = 'gold'
export const BRAND_MAINTU = 'mantu'
export const BRAND_KIDS = 'kids'
export const BRAND_XIUXIU = 'xiuxiu'
export const BRAND_GIFT_CARD = 'gift-card'
export const BRAND_HIMORE_MART = 'himore-mart'
export const BRAND_FAMILY = 'family'

// 门店品牌id
export const BRAND_HIMO_ID = 1
export const BRAND_HIMOGOLD_ID = 2
export const BRAND_FAMILY_ID = 3
export const BRAND_KIDS_ID = 4
export const BRAND_MAINTU_ID = 5

// 礼品卡
export const GIFT_CARD = 'gift-card'
export const GIFT_CARD_ID = 6
// himore商城
export const HIMORE_MART = 'himore-mart'
export const HIMORE_MART_ID = 7

// 门店品牌id与品牌名映射
export const BRAND_MAP = {
  [BRAND_HIMO_ID]: '海马体',
  [BRAND_HIMOGOLD_ID]: '海马体大师',
  [BRAND_FAMILY_ID]: '海马体家庭',
  [BRAND_KIDS_ID]: 'himokids',
  [BRAND_MAINTU_ID]: '缦图摄影'
}

// 门店品牌code与品牌名映射
export const BRAND_CODE_MAP = {
  [BRAND_HIMO]: '海马体',
  [BRAND_HIMOGOLD]: '海马体大师',
  [BRAND_FAMILY]: '海马体家庭',
  [BRAND_KIDS]: 'himokids',
  [BRAND_MAINTU]: '缦图摄影'
}
